// extracted by mini-css-extract-plugin
export default {"popconfirm-title":"popConfirm_popconfirm-title__jW4ng","popconfirm-description":"popConfirm_popconfirm-description__nyM2Y","footer-buttons":"popConfirm_footer-buttons__Cmx3c"};